module.exports = __webpack_public_path__ + "img/16@2x.506d2899.png";